import { useLoaderData } from "react-router-dom";
import PageTransition from "./templateParts/PageTransition";
import renderModules from "./renderModules";

const Page = () => {
  const data = useLoaderData();

  return <PageTransition>{renderModules(data)}</PageTransition>;
};

export default Page;
